// @ts-nocheck
import * as React from "react"
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// TEST
//import { towns } from "../../config/constants";

// Components
import Loader from "../Loader";
import Banner from "../Banner";
import RankingList from "../RankingList";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';
enum AgeCategory { infantil, juvenil }

export const Ranking = ({ setLoading, loading, data }: ComponentArticles) => {
    const [visibleAll, setVisibleAll] = React.useState(false);
    const [activeTown, setActiveTown] = React.useState<number>(0)
    const [activeCategory, setActiveCategory] = React.useState<number>(0)

    const townsData = [
        {
            title: 'Apan',
            infantil: {
                title: "Infantil: 6 - 8 años",
                list: [...data.dataRankingApanInfantil]
            },
            juvenil: {
                title: "Junior: 9 - 11 años",
                list: [...data.dataRankingApanJunior]
            }
        }, 
        {
            title: "Calera",
            infantil: {
                title: "Infantil: 6 - 8 años",
                list: [...data.dataRankingCaleraInfantil]
            },
            juvenil: {
                title: "Junior: 9 - 11 años",
                list: [...data.dataRankingCaleraJunior]
            }
        }
    ]

    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500);
    }, []);

    const showMore = () => {
        setVisibleAll(true)
    }

    const changeSection = (index: number) => {
        setVisibleAll(false)
        setActiveTown(index)
    }

    const changeCategory = ({ target }: any) => {
        setVisibleAll(false)
        setActiveCategory(AgeCategory[target.value])
    }

    return (
        <main className="ranking">
            <Banner
                backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/gallery/bg-gallery.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/gallery/bg-gallery.jpg` }}
                textBanner={window.drupalSettings.react.node.dataNode.field_title}
                // textBanner={!loading ? data.dataNode.field_title : ''}
                textDescription={window.drupalSettings.react.node.dataNode.field_desc}
                // textDescription={data.dataNode.field_desc }
                newBanner={1}
            />
            <div className="ranking__content">
                <div className="ranking-container">
                    <section className="af-ranking-tabs">
                        {townsData.map(({ title }: AlliesCard, indexButton: number) => (
                            <div key={indexButton} className="af-ranking-tabs__item">
                                <div className={`af-ranking-tabs__button${indexButton == activeTown ? ' active' : ''}`} onClick={() => changeSection(indexButton)}>{title}</div>
                            </div>
                        ))}
                    </section>
                    <select className="ranking-container__select" onChange={changeCategory}>
                        <option value="infantil">Infantil: 6 - 8 años</option>
                        <option value="juvenil">Junior: 9 - 11 años</option>
                    </select>
                    <div className="ranking-container__body" >
                        <RankingList className={`ranking-container__section ${activeCategory == 0 ? "ranking-container__section--visible" : ""}`} rankingTitle={townsData[activeTown].infantil.title} rankingList={townsData[activeTown].infantil.list} visibleAll={visibleAll} />
                        <RankingList className={`ranking-container__section ${activeCategory == 1 ? "ranking-container__section--visible" : ""}`} rankingTitle={townsData[activeTown].juvenil.title} rankingList={townsData[activeTown].juvenil.list} visibleAll={visibleAll} />
                    </div>
                    {(!visibleAll && townsData[activeTown].infantil.list.length > 5 || !visibleAll && townsData[activeTown].juvenil.list.length > 5) && <button className="af-submit-button af-submit-button--block ranking-container__button" data-aos="fade-in" onClick={showMore}>Cargar más</button>}
                </div>
                <div className="btnSeeRanking">
                    <a href="/galeria">Ver galeria</a>
                </div>
            </div>
        </main>
    )
}

export default Loader(Ranking)